import React, { ReactNode } from 'react';

import { BasicButton } from '@adsk/alloy-react-button';

type CloseButtonTokens = {
  width?: string;
  height?: string;
  color?: string;
  'margin-left'?: string;
  'align-self'?: string;
};

type NotificationCloseButtonProps = {
  tokens?: CloseButtonTokens;
  onClick?: () => void;
  children: ReactNode;
};

/** Dismiss button for the notification toast, styled entirely from `close-button` tokens. */
export default function NotificationCloseButton({
  tokens,
  onClick,
  children,
}: NotificationCloseButtonProps) {
  return (
    <BasicButton
      aria-label="close"
      onClick={onClick}
      style={{
        width: tokens?.width,
        height: tokens?.height,
        color: tokens?.color,
        marginLeft: tokens?.['margin-left'],
        alignSelf: tokens?.['align-self'],
      }}
    >
      {children}
    </BasicButton>
  );
}
